import React from 'react';
import PropTypes from 'prop-types';
import { numberFormatter } from '../../../../utils/number';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import {
  parcelIncomeSummaryPropTypes,
  parcelPaymentMethodSummaryListPropTypes,
} from './SalesSessionPropTypes';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import ParcelsTable from './ParcelsTable';
import { Col, Row } from 'reactstrap';
import Table from '../../../common/Table';
import Badge from '../../../common/Badge';
import { generateSalesSessionParcelDownloadEndpoint } from '../../../../config/endpoints';

const ParcelIncomeSummary = ({
  parcelIncomeSummaryList,
  salesSessionId,
  parcelPaymentMethodSummaryList,
}) => {
  if (!parcelIncomeSummaryList.length) {
    return null;
  }

  let totalAmount = 0;
  parcelIncomeSummaryList.forEach((parcel) => {
    totalAmount += parcel.totalAmount;
  });

  const clearVoucherPrefix = (serie) => {
    if (serie && (serie.startsWith('B') || serie.startsWith('F'))) {
      return serie.substring(1);
    }
    return serie;
  };

  const getParsedDocumentSeries = (parcelSummary) => {
    if (parcelSummary.contingency) {
      return clearVoucherPrefix(parcelSummary.documentSeries);
    }
    return parcelSummary.documentSeries;
  };

  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Carga"
        component={ParcelsTable}
        salesSessionId={salesSessionId}
        downloadButton
        downloadEndpoint={generateSalesSessionParcelDownloadEndpoint}
        downloadLabel="Descargar encomiendas"
      />
      <Row>
        <Col>
          <Table
            columns={[
              {
                Header: 'Tipo de Comprobante de Pago',
                accessor: 'voucherType',
                className: 'text-center',
                Cell: (row) => {
                  if (row.original.contingency) {
                    const text = row.value.replace(/electronica/gi, '');
                    return (
                      <>
                        {text} -{' '}
                        <Badge
                          className={'bg-secondary text-white'}
                          text="Contingencia"
                        />
                      </>
                    );
                  }
                  return <>{row.value}</>;
                },
              },
              {
                Header: 'Serie',
                accessor: 'documentSeries',
                className: 'text-center',
                Cell: (row) => {
                  return getParsedDocumentSeries(row.original);
                },
              },
              {
                Header: 'Total de Ventas',
                accessor: 'totalAmount',
                Cell: ({ value }) => numberFormatter({ value }),
                Footer: (row) =>
                  `Total: ${numberFormatter({
                    value: row.data.reduce(
                      (accumulated, data) => accumulated + data.totalAmount,
                      0,
                    ),
                  })}`,
                className: 'text-right',
              },
            ]}
            data={parcelIncomeSummaryList}
            defaultPageSize={parcelIncomeSummaryList.length}
            showPagination={false}
          />
        </Col>
      </Row>
      <br />
      {parcelPaymentMethodSummaryList.map((paymentMethodSales) => (
        <ResourceProperty
          key={paymentMethodSales.moneyFlowConcept}
          label={`${paymentMethodSales.moneyFlowConcept}: `}
        >
          {numberFormatter({ value: paymentMethodSales.totalAmount })}
        </ResourceProperty>
      ))}
      <ResourceProperty label="Total de Ventas de Carga: ">
        {numberFormatter({ value: totalAmount })}
      </ResourceProperty>
    </>
  );
};

ParcelIncomeSummary.propTypes = {
  parcelIncomeSummaryList: parcelIncomeSummaryPropTypes.isRequired,
  parcelPaymentMethodSummaryList:
    parcelPaymentMethodSummaryListPropTypes.isRequired,
  salesSessionId: PropTypes.number.isRequired,
};

export default ParcelIncomeSummary;
